import { ShoppingBag, Shield, Truck, Heart, Award, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';

const features = [
  {
    icon: ShoppingBag,
    title: 'Premium Quality',
    description: 'Hand-picked fashion from trusted brands',
    color: 'primary'
  },
  {
    icon: Shield,
    title: '100% Authentic',
    description: 'Guaranteed genuine products always',
    color: 'discount'
  },
  {
    icon: Truck,
    title: 'Fast Shipping',
    description: 'Quick delivery across India',
    color: 'aurakart-blue'
  },
  {
    icon: RefreshCw,
    title: 'Easy Returns',
    description: '15-day hassle-free returns',
    color: 'aurakart-green'
  },
  {
    icon: Award,
    title: 'Best Prices',
    description: 'Competitive pricing guaranteed',
    color: 'aurakart-yellow'
  },
  {
    icon: Heart,
    title: '24/7 Support',
    description: 'Always here to help you',
    color: 'destructive'
  }
];

export function WhyChooseUs() {
  return (
    <section className="py-16 md:py-24 bg-secondary/50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="inline-block text-primary font-medium text-sm uppercase tracking-wider mb-3 font-sans">
            Why Shop With Us
          </span>
          <h2 className="section-heading font-serif">
            The <span className="text-gradient-warm">AURAKART</span> Promise
          </h2>
          <p className="section-subheading max-w-md mx-auto font-sans">
            We're committed to delivering the best shopping experience
          </p>
        </motion.div>
        
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="group bg-card rounded-2xl p-6 md:p-8 shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 mb-5 rounded-2xl bg-${feature.color}/10 flex items-center justify-center transition-transform duration-300 group-hover:scale-110`}>
                <feature.icon className={`h-7 w-7 text-${feature.color}`} />
              </div>
              <h3 className="font-semibold text-lg mb-2 font-serif">{feature.title}</h3>
              <p className="text-sm text-muted-foreground font-sans">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
